import {
  createAddFeedbackModel,
  IAddFeedbackRequestSchema,
  TAddFeedbackResponseSchema,
} from '@cian/api-models/user-notes/v1/add-feedback';
import { IHttpApi } from '@cian/http-api';

export function apiAddFeedback(
  httpApi: IHttpApi,
  parameters?: IAddFeedbackRequestSchema,
): Promise<TAddFeedbackResponseSchema> {
  return httpApi.fetch(createAddFeedbackModel({ parameters }));
}
